import {
    SelectCentroCusto,
    SelectFuncionarios as SelectComp,
    SelectLocais,
} from '@/global/components/Selects'
import { SimpleTabs } from '@/global/components/Tabs'
import { useAuth } from '@/hooks'
import { useStore } from '@/store'
import { CategoriaEnum } from '@acme/auth/roles'
import { Divider, Grid } from '@mui/material'

type Props = {
    /** Funcionários já vinculados — aparecem marcados e desabilitados */
    checked?: number[]
} & (
    | {
          funcionarioIds: number[]
          onChange: (ids: number[]) => void
          formName?: never
      }
    | {
          funcionarioIds?: never
          onChange?: never
          formName: string
      }
)

export default function TabFuncionariosForm(props: Props) {
    const {
        decoded: { categoria },
    } = useAuth()
    const setCentroCustoId = useStore(state => state.setCostCenterId)
    const setLocais = useStore(state => state.setLocaisIds)

    if (categoria === CategoriaEnum.Funcionario) {
        return null
    }

    return (
        <Grid item xs={12} key="funcionarios">
            <Divider className="mb-2">Funcionários</Divider>
            <SimpleTabs
                onChange={() => {
                    setCentroCustoId(-1)
                    setLocais([])
                }}
                className="mb-4"
                tabs={[
                    {
                        value: 'nao-filtrar',
                        label: 'Todos',
                        content: (
                            <BoxSelects>
                                <CompSelect {...props} />
                            </BoxSelects>
                        ),
                    },
                    {
                        value: 'centro-custo',
                        label: 'Por centro de custo',
                        content: (
                            <BoxSelects>
                                <SelectCentroCusto
                                    width="100%"
                                    key="centro-custo"
                                    size="medium"
                                />
                                <CompSelect {...props} />
                            </BoxSelects>
                        ),
                    },
                    {
                        value: 'local',
                        label: 'Por local',
                        content: (
                            <BoxSelects>
                                <SelectLocais
                                    width="100%"
                                    key="locais"
                                    size="medium"
                                />
                                <CompSelect {...props} />
                            </BoxSelects>
                        ),
                    },
                ]}
            />
        </Grid>
    )
}

function CompSelect(props: Props) {
    return (
        <SelectComp
            key="funcionarios"
            defaultValues={props.funcionarioIds}
            onChange={props.onChange}
            form={props.formName}
            checked={props.checked}
            helperText=" "
            width="100%"
            size="medium"
            useFilter
        />
    )
}

function BoxSelects({ children }: { children: React.ReactNode }) {
    return <div className="flex size-full gap-4 pt-4 flex-col">{children}</div>
}
